import type { MetricsRecheckResponse } from '@discovr/features';
import type { MetricsBaseline } from './creatorMetricsStatus';
import { MetricsRecheckButton } from './MetricsRecheckButton';
import { useIsRechecking } from './profileRecheckStore';

type MetricsRecheckSlotProps = {
  campaignId: string;
  entryId: string;
  handle: string | undefined;
  metrics: MetricsBaseline;
  /** showMetricsRecheck(...) for this row — the status-derived half of the gate. */
  showRecheck: boolean;
  recheck: (entryId: string) => Promise<MetricsRecheckResponse>;
};

/** The Avg Views ⟳ slot. Mounted for every admin row; decides here — not in
 *  the cell renderer, which cannot call hooks — whether the button exists.
 *
 *  The button must outlive the fresh-`pending` window: showMetricsRecheck
 *  hides the ⟳ there, but unmounting the button would run its cleanup and
 *  drop the store baseline, and with it the poll that carries the row to a
 *  terminal status. So the button also stays while THIS viewer's re-check is
 *  settling — RowRecheckButton shows its spinner for that — and unmounts only
 *  once a terminal status lands, which is when the cleanup should fire. */
export function MetricsRecheckSlot({ campaignId, entryId, handle, metrics, showRecheck, recheck }: MetricsRecheckSlotProps) {
  const settling = useIsRechecking(campaignId, entryId, 'metrics', metrics);
  if (!showRecheck && !settling) return null;
  return (
    <MetricsRecheckButton
      campaignId={campaignId}
      entryId={entryId}
      handle={handle}
      metrics={metrics}
      recheck={recheck}
      pending={settling}
    />
  );
}
